"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * changeLanguage - changes the language and reloads the page
 * We want to refresh the browser to reflect the user experience of the future,
 * which will rely on unique URLs and server side bootstrapping of language
 * strings
 *
 * Simply automagically translating without triggering a hard refresh doesn't
 * reflect the future UX so we will avoid it altogether
 *
 * @param {string} lang - the locale string. i.e. en-US, fr-CA
 */
function _changeLocale(i18nextInstance, lang) {
    return i18nextInstance.changeLanguage(lang);
}
exports.default = _changeLocale;
